import React from "react";
import {WizTableForm} from '@/containers/common'

const program = WizTableForm.Config.program(this, {apiParams: {isPower: true}})
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}

//配置项
const componentName = "programReport";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "课程名称",
      name: "programName",
      tableItem: {},
    },
    {
      title: "课程名称",
      name: "programId",
      searchItem: {
        ...program,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择课程名称'
          }
        ]
      },
    },
    {
      title: "课程编码",
      name: "scoId",
      tableItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryName",
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        treeCheckable: true
      }
    },
    {
      title: "省份",
      name: "province",
      tableItem: {},
      searchItem: {}
    },
    {
      title: "应学习人数",
      name: "shoudCount",
      tableItem: {},
    },
    {
      title: "已学习人数",
      name: "factCount",
      tableItem: {},
    },
    {
      title: "课程学习率",
      name: "rate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "已通过人数",
      name: "passCount",
      tableItem: {},
    },
    {
      title: "通过率",
      name: "passRate",
      tableItem: {
        render: text => text + '%'
      },
    }
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        },
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListProgramOrg`,
    payload: {
      key: `${componentName}@getPageListProgramOrg`,
      apiParams: {pageNum: 1, pageSize: 10},
    },
  },
  export: {
    path: `${componentName}/exportProgramOrg`,
    payload: {
      key: `${componentName}@exportProgramOrg`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export {reduxTemplateCofig, templateConfig};
